import {
  Button,
  Modal,
  Form,
  Input,
  Typography,
  DatePicker,
  Row,
  Col,
  message,
  Spin,
  Select,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";

const VendorTypeModal = forwardRef(({ onSuccess }, ref) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [vendorTypes, setVendorTypes] = useState([]);

 
  const [glAcctLoading, setGlAcctLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});

  const fetchInitialData = async () => {
    setGlAcctLoading(true);
    try {
      const [vendorTypesResponse, ] =
        await Promise.all([
          http.get(api.getVendorType, { params: { flag: "status" } }),
         
        ]);

      setVendorTypes(
        (vendorTypesResponse || []).map((item, index) => ({
          value: item.typeCode,
          label: item.typeName,
          key: `${item.typeCode}-${index}`,
        })),
      );
    } catch (error) {
      console.error("Failed to load vendor dropdown data:", error);
    } finally {
      setGlAcctLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    open: async (record) => {
      setCurrentRecord(record || {});
      setVisible(true);
      form.resetFields();
      setOpenLoading(true);
      console.log(record);
      try {
        await fetchInitialData();
        const response = await http.get(api.getVendorMonthlyById, {
          params: { id: record?.id },
        });
        const data = response?.data || {};
        form.setFieldsValue({
          vendorId: data?.vendorId ?? record?.vendorId,
          vendorName: data?.name,
          vendorType: data?.vendorType ?? undefined,
          endDate: data?.endDate ? dayjs(data.endDate) : null,
        });
      } catch (error) {
        message.error("Failed to load data.");
      } finally {
        setOpenLoading(false);
      }
    },
  }));

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setCurrentRecord({});
    setOpenLoading(false);
    setSubmitLoading(false);
    setVendorTypes([]);
  };

  const submitFn = async () => {
    try {
      const values = await form.validateFields();
      setSubmitLoading(true);
      const response = await http.post(api.getChangeVendorType, {
        vendorId: values?.vendorId ?? currentRecord?.vendorId,
        vendorType: values?.vendorType,
        endDate: values?.endDate?.format?.("YYYY-MM-DD") || null,
      });
      if (response?.code === "1") {
        message.success("Change vendor type successfully.");
        handleCancel();
        onSuccess?.();
        return;
      }

      commonFn.modalFailedFn(response);
    } catch (error) {
      if (error?.errorFields) {
        return;
      }
      message.error("Submit failed.");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Row justify="start" align="middle" className="model_title">
          <Col>
            <EditOutlined className="model_title_mr10" />
          </Col>
          <Col>
            <Typography.Title level={4} className="mg">
              CHANGE VENDOR TYPE
            </Typography.Title>
          </Col>
        </Row>
      }
      width="60%"
      open={visible}
      confirmLoading={openLoading}
      onCancel={handleCancel}
      maskClosable={false}
      styles={{
        body: {
          minHeight: 260,
        },
      }}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button onClick={handleCancel} disabled={openLoading || submitLoading}>
            Cancel
          </Button>
          <Button
            type="primary"
            loading={submitLoading}
            disabled={openLoading}
            onClick={submitFn}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Spin spinning={openLoading || glAcctLoading} tip="Loading...">
        <div
          className="model_top"
          style={{ width: "100%", minHeight: 220, display: "flex" }}
        >
          <div className="model_content" style={{ width: "100%" }}>
            <Form
              form={form}
              name="vendorTypeForm"
              layout="horizontal"
              style={{ width: "100%" }}
              validateMessages={{
                required: "${label} is required!",
              }}
            >
              <Form.Item name="vendorId" hidden>
                <Input />
              </Form.Item>

              <Form.Item name="vendorName" label="Vendor Name">
                <Input readOnly />
              </Form.Item>

              <Form.Item
                name="vendorType"
                label="Vendor Type"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Please Select Vendor Type"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={vendorTypes}
                />
              </Form.Item>

              <Form.Item name="endDate" label="End Date" rules={[{ required: true }]}>
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  picker="date"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Spin>
    </Modal>
  );
});

export default VendorTypeModal;
